import { render, staticRenderFns } from "./SetNewPassword.vue?vue&type=template&id=367061af&scoped=true"
import script from "./SetNewPassword.vue?vue&type=script&lang=ts"
export * from "./SetNewPassword.vue?vue&type=script&lang=ts"
import style0 from "./SetNewPassword.vue?vue&type=style&index=0&id=367061af&prod&lang=scss"
import style1 from "./SetNewPassword.vue?vue&type=style&index=1&id=367061af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367061af",
  null
  
)

export default component.exports